"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgMic = function SvgMic(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M87.392 64.486c0 10.931-8.855 19.799-19.791 19.799H60.39c-10.921 0-19.781-8.868-19.781-19.799V20.789C40.608 9.859 49.468 1 60.39 1h7.211c10.936 0 19.791 8.859 19.791 19.789v43.697z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.945 38.537a6.072 6.072 0 0 0-6.072 6.072v25.264c-.002 2.76-.627 5.358-1.789 7.783-1.739 3.627-4.734 6.856-8.642 9.177-3.904 2.32-8.688 3.716-13.907 3.715H58.457c-6.945.004-13.133-2.486-17.486-6.319-2.177-1.915-3.891-4.154-5.055-6.574-1.163-2.424-1.788-5.022-1.79-7.781V44.609a6.072 6.072 0 1 0-12.144 0v25.264a30.015 30.015 0 0 0 2.99 13.045c2.875 5.973 7.589 10.909 13.387 14.355 5.232 3.108 11.377 5.002 17.946 5.347v18.875A5.509 5.509 0 0 0 61.823 127h4.36c3.036 0 5.52-2.461 5.52-5.505v-18.866c9.001-.476 17.191-3.866 23.353-9.282 3.324-2.925 6.063-6.45 7.976-10.431a30.022 30.022 0 0 0 2.987-13.043V44.609a6.074 6.074 0 0 0-6.074-6.072z",
    fill: "#232323"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgMic);
var _default = exports["default"] = Memo;